import {
  Component,
  OnInit,
  AfterViewInit,
  OnDestroy,
  Input,
} from '@angular/core';
import { Subject, Observable, EMPTY } from 'rxjs';
import { Router, RouterEvent, NavigationStart } from '@angular/router';
import { takeUntil, catchError, map } from 'rxjs/operators';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-help-modal',
  templateUrl: './help-modal.component.html',
  styleUrls: ['./help-modal.component.css'],
})
export class HelpModalComponent implements OnInit, OnDestroy, AfterViewInit {
  show = false;
  noContent = false;
  @Input() content$: Observable<any>;
  private onDestroy$: Subject<void> = new Subject();

  constructor(private activeModal: NgbActiveModal, private router: Router) {}

  ngOnInit(): void {
    this.content$ = this.content$.pipe(
      map((content) => {
        if (!content.content) {
          content.content = '';
        }
        return content;
      }),
      catchError(() => {
        this.noContent = true;
        return EMPTY;
      }),
    );

    this.router.events
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((event: RouterEvent) => {
        if (event instanceof NavigationStart) {
          this.activeModal.dismiss();
        }
      });
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      const dialog = document.getElementsByClassName('modal-dialog')[0];
      dialog.classList.add('modal-dialog-scrollable');
      // dialog.classList.add('modal-dialog-vertical');
      // dialog.classList.add('modal-dialog-vertical-lg');
      // dialog.classList.add('border-left');
      this.show = true;
    }, 1);
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  onClose(): void {
    this.activeModal.close();
  }
}
